<template>
  <div class="uploadMaterial">
    <div class="header">
      <h3><i></i>上传素材</h3>
      <img @click="close()" src="../../../../static/images/close.png"/>
    </div>
    <div class="material-site">
      <el-form :model="materialForm" ref="materialForm">
        <template>
          <div class="sub">
            <el-form-item label="科目:" label-width="53px">
              <el-input v-model="materialObjData.name" readonly disabled  placeholder="科目"></el-input>
            </el-form-item>

            <el-form-item label="知识点:" prop="taskName">
              <el-cascader
                ref="cascader"
                placeholder="全部"
                :options="cascaderOptions"
                v-model="selectedOptions"
                :props="{checkStrictly: true,expandTrigger: 'hover'}"
                filterable
                clearable
                show-all-levels
                popper-class="mycascader"
              >
              </el-cascader>
            </el-form-item>
          </div>

        </template>

        <el-form-item
          label="选择文件:"
          prop="materialUpload"
        >
          <el-upload
            ref="addUpload"
            :action="materialForm.upload.url"
            :data="materialForm.upload.data"
            :headers="headers"
            :show-file-list="false"
            :with-credentials="true"
            :on-success="handleAvatarSuccess"
            :on-error="handleAvatarError"
            :before-upload="beforeAvatarUpload"
            :on-progress="uploadProgress"
            :on-preview="handlePreview"
            multiple
          >
            <div class="el-upload__text"><img src="../../../assets/image/sources/add.png" alt=""></div>
          </el-upload>
        </el-form-item>
        <div class="text-p">
          <div class="el-upload__tip" slot="tip">
            <span>格式说明：</span>
            <p class="tis-p">文档：支持doc.docx.ppt.pptx.pdf.xlsx格式 <br/><span> 图片：支持png.jpg.jpeg格式10M以内</span> <br/><span>视频：支持asx.asf.mpg.3gp.mp4.mov.avi.flv格式</span><br/> <span> 音频：支持mp3格式 </span> <br/><span>课件包：支持zip格式</span></p>
          </div>
        </div>

        <!--<el-button type="primary" size="mini" @click="submitForm" class="addmater">提 交</el-button>-->
      </el-form>
      <div class="uploadList">
        <div class="uploadCompleted" >
          <el-button round size="mini" :class="['upload',isUploadingChecked?'active':'']" @click="uploading">正在上传</el-button>
          <el-button round size="mini" :class="['upload',isUploadCompletedChecked?'active':'']" @click="uploadCompleted">上传完成</el-button>
          <!-- <el-button v-if="showText!=''" class="showText" round size="mini"  @click="clearAllCompleted">{{showText}}</el-button> -->
          <p>共<span>{{showUploadFileList.filter(x =>x.state==showState).length}}</span>条</p>
          <!-- <el-row>
            <el-col :span="1"><span>序号</span></el-col>
            <el-col  :span="3"><span>科目</span></el-col>
            <el-col :span="3"><span>素材目录</span></el-col>
            <el-col  :span="3"><span>类型</span></el-col>
            <el-col :span="3"><span>素材名称</span></el-col>
            <el-col  :span="5">
              <el-col :span="8">
                <span>大小</span>
              </el-col>
              <el-col  :span="16">
                <span>上传进度</span>
              </el-col>
            </el-col>
            <el-col  :span="3"><span>上传状态</span></el-col>
            <el-col  :span="3" ><span>操作</span></el-col>
          </el-row> -->
        </div>
        <div v-if="isUploadingChecked" :style="'height:'+(windowHeight-210)+'px; overflow-y: auto;'">
          <el-row  v-for="(site,index) in showUploadFileList.filter(x =>x.state!='已完成')" :key="index">
            <el-col  :span="5" :title="materialObjData.name"><span>科目</span>{{materialObjData.name}}</el-col>
            <el-col :span="5" :title="site.materialName"><span>素材目录</span>{{site.materialName}}</el-col>
            <el-col  :span="5" :title="site.name"><img :src="site.img" alt="">{{site.name}}</el-col>
            <el-col  :span="5" v-if="site.state!='已完成'">
              <el-col :span="8">
                <em>{{site.size | computeFileSize}}</em>
              </el-col>
              <el-col  :span="16">
                <el-progress :percentage="site.percentage" color="#409eff" :stroke-width="10"></el-progress>
              </el-col>
            </el-col>
            <el-col  :span="4" v-if="site.state=='上传中'"><b><i></i>{{site.state}}</b><em></em><strong class="imgPicDel" @click="uploadDel(site)"></strong></el-col>
            <el-col  :span="4" v-if="site.state=='上传失败'"><b style="color: #F56C6C"><i style="background: #F56C6C"></i>{{site.state}}</b><em class="imgPic" @click="reloadUpload(site)"></em><strong class="imgPicDel" @click="uploadDel(site)"></strong></el-col>
          </el-row>

        </div>
        <div v-if="isUploadCompletedChecked" :style="'height:'+(windowHeight-210)+'px; overflow-y: auto;'">
          <el-row  v-for="(site,index) in showUploadFileList.filter(x =>x.state=='已完成')" :key="index">
            <el-col  :span="5" :title="materialObjData.name"><span>科目</span>{{materialObjData.name}}</el-col>
            <el-col :span="5"  :title="site.materialName"><span>素材目录</span>{{site.materialName}}</el-col>
            <el-col  :span="5" :title="site.name"><img :src="site.img" alt="">{{site.name}}</el-col>
            <el-col  :span="3" v-if="site.state=='已完成'">
              <el-col :span="16">
                <em>{{site.size |computeFileSize}}</em>
              </el-col>
            </el-col>
            <el-col  :span="4" v-if="site.state=='已完成'"><b><i></i>{{site.state}}</b><span class="dataTime" :title="site.createTime">{{site.createTime}}</span><em></em><strong class="imgPicDel" @click="uploadDel(site)"></strong></el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import bus from "../../../vendor/eventbus";
    import { mapState } from "vuex";
    import axios from 'axios';
    import {formatTime} from '../../../utils/utils'
    import * as api from '../../../api/sourceApi'
    export default {
        name: "uploadMaterial.vue",
        data(){
            return{
                materialViewDialog: {
                    type: 0,
                    url: "",
                },
                materialForm: {
                    id: "",
                    materialName: "",
                    materialsort: "",
                    materialPic: "",
                    uploader: "",
                    uploadTime: "",
                    upload: {
                        url: `${process.env.UPLOAD_NAME}${this.uploadUrl?this.uploadUrl:'/fileUpload/uploadFile'}`,
                        data: {
                            savepath: "cjdd/resourse/",
                        },
                        type: "",
                    },
                    uploadRes: {},
                },

                formLabelWidth: "120px",
                materialObjData:{},
                imageUrl: require("../../../../static/images/sourceIcon/file.png"),
                cascaderProps: {
                    value: "id",
                    label: "name",
                    checkStrictly: true,
                    expandTrigger: "hover",
                },
                cascaderOptions: [],
                selectedOptions: [],
                showUploadFileList:[],
                showState:"上传中",
                isUploadingChecked:true,
                showText:"取消全部",
                isUploadFail:false,
                isUploadCompletedChecked:false,
                windowHeight: window.innerHeight
            }
        },
        computed: {
            // ...mapState({
            //     floaterTag: (state) => state.app.floaterOpened,
            // }),

            headers() {
                return {
                    Authorization: "bearer " + localStorage.getItem("Authorization"),
                };
            },
        },
        created() {
            //创建bus事件，记录页面滚动位置
            // bus.$on(this.$options.name + ".init", this.init);

        },
        beforeDestroy() {
            //离开页面，清除数据
            // bus.$off(this.$options.name + ".init", this.init);
        },
        props:["subjectId", "isUploadMaterial","uploadUrl","categoryId","projectId"],
        mounted() {
            // if (!this.floaterTag) {
            //     this.init(); // 初始化
            // }
            // this.getCourseInfo(); // 初始化
            this.init()
        },
        watch: {
            selectedOptions() {
                if (this.$refs.cascader) {
                    this.$refs.cascader.dropDownVisible = false; //监听值发生变化就关闭它
                }
            },
            "isUploadMaterial":function(val){
              if(val){
                this.showUploadFileList = []
                this.isUploadingChecked = true
                this.isUploadCompletedChecked = false
                this.selectedOptions = []
              }
            }
        },
        filters: {
            computeFileSize (byteSize){
                let temp = byteSize / (1024*1024);
                temp = temp.toFixed(2);
                return temp + 'M';
            }

        },
        methods:{
            init() {
                api.getMaterialTreeListById(this.subjectId,{}).then(res =>{
                    if(res.code=="0"){
                        this.materialObjData.name = res.data.name;
                        this.cascaderOptions = formatData(res.data.materials)
                    }else{
                      this.$messageError(res.msg)
                    }
                });
                // let parma = args.params.materialObjData;
                // this.materialObjData=parma;
                // this.cascaderOptions = formatData(parma.materials)
                // this.selectedOptions= parma.arrIds;
                // this.materialForm.upload.data.materialId = parma.id;
            },
            getCourseInfo(){
                let courseid = this.$route.query.id;
                api.getCourseInfo(courseid).then((rs)=>{
                    if(rs.code==0){
                        this.subjectId = rs.data.subjectId;
                        this.init();
                    }else{
                      this.$messageError(rs.msg)
                    }
                }).catch((error)=>{
                    console.log(error)
                })
            },
            // 重新上传
            reloadUpload(site){
                const form = new FormData();
                form.append('file',site.file)
                form.append("savepath", 'cjdd/resourse/');
                form.append('materialId',this.materialForm.upload.data.materialId)
                let uploadProgress = (progressEvent)=>{
                    this.uploadProgress({},{uid: site.uid,percentage: progressEvent.loaded / progressEvent.total * 100, type: 'reload'})
                }
                if(this.uploadUrl){
                  this.$set(this.headers, 'projectId', this.projectId)
                  this.$set(this.headers, 'categoryId', this.categoryId)
                }
                axios({
                    method: 'post',
                    url: `${process.env.UPLOAD_NAME}${this.uploadUrl?this.uploadUrl:'/fileUpload/uploadFile'}`,
                    data: form,
                    headers: this.headers,
                    onUploadProgress: uploadProgress
                }).then(res=>{
                    this.handleAvatarSuccess(res,{uid: site.uid})
                }).catch(err=>{
                    this.handleAvatarSuccess(err,{uid: site.uid})
                })
            },
            beforeAvatarUpload(file, fileList){
                let userId = sessionStorage.getItem("userId");
                let orgId = sessionStorage.getItem("deptId");
                let materialName = "";
                this.$set(this.headers, 'subjectId', this.subjectId)
                if(this.uploadUrl){
                  this.$set(this.headers, 'projectId', this.projectId)
                  this.$set(this.headers, 'categoryId', this.categoryId)
                }
                if(this.$refs['cascader'].getCheckedNodes(false).length ==0){
                    materialName="全部";
                    // this.$set(this.headers, 'subjectId', this.materialObjData.id)
                }else {
                    let  materialId = this.$refs['cascader'].getCheckedNodes(false)[0].value;
                    materialName = this.$refs['cascader'].getCheckedNodes(false)[0].label;
                    this.$set(this.headers, 'materialId', materialId)
                    // this.$set(this.headers, 'subjectId', this.materialObjData.id)
                }
                this.$set(this.headers, 'userId', userId)
                this.$set(this.headers, 'orgId', orgId)
                let fileSize = file.size;
                let name = file.name;
                if (name.length > 200) {
                    this.$message.warning("名字长度过长,请重新选择");
                    return;
                }
                let suffix = name.substring(name.lastIndexOf(".") + 1);
                let docArr = ["docx","DOCX","doc", "DOC", "ppt", "PPT", "pptx", "PPTX", "pdf", "PDF", "xlsx", "XLSX", ];
                let auditArr  = ["mp4","MP4","avi","AVI","asx","ASX","asf","ASF","mpg","MPG","3gp","3GP","mov","MOV","avi","AVI","flv","FLV"]
                if (docArr.indexOf(suffix) != -1) {
                    if (fileSize > 104857600) {
                        this.$message.warning("上传文件不能大于100M");
                        return;
                    }
                    //上传类型 2 文档
                    this.materialForm.upload.type = 2;
                    let {name,size,uid} =file;
                    let obj = {name,size,uid,state:"上传中",img:require('../../../../static/images/sourceIcon/file.png'),materialName,file};
                    this.showUploadFileList.push(obj);


                } else if (auditArr.indexOf(suffix) != -1) {
                    if (fileSize > 2147483648) {
                        //2147483648 2G
                        this.$message.warning("上传视频文件不能大于2G");
                        return;
                    }

                    //上传类型 4  视频
                    this.materialForm.upload.type = 4;
                    let {name,size,uid} =file;
                    let obj = {name,size,uid,state:"上传中",img:require('../../../../static/images/sourceIcon/video.png'),materialName,file};
                    this.showUploadFileList.push(obj);

                } else if (suffix == "mp3") {
                    if (fileSize > 31457280) {
                        //31457280 2G
                        this.$message.warning("上传音频文件不能大于30M");
                        return;
                    }

                    //上传类型 3  音频
                    this.materialForm.upload.type = 3;
                    let {name,size,uid} =file;
                    let obj = {name,size,uid,state:"上传中",img:require('../../../../static/images/sourceIcon/audio.png'),materialName,file};
                    this.showUploadFileList.push(obj);
                } else if (suffix == "jpg" || suffix == "png" || suffix == "jpeg") {
                    if (fileSize > 10485760) {
                        //104857600 10M
                        this.$message.warning("上传图片不能大于10M");
                        return;
                    }
                    //上传类型 1  图片
                    this.materialForm.upload.type = 1;
                    let {name,size,uid} =file;
                    let obj = {name,size,uid,state:"上传中",img:require('../../../../static/images/sourceIcon/pic.png'),materialName,file};
                    this.showUploadFileList.push(obj);
                } else if (suffix == "zip") {
                    if (fileSize > 104857600) {
                        //104857600 100M
                        this.$message.warning("上传压缩包不能大于100M");
                        return;
                    }
                    this.materialForm.upload.type = 5;
                    this.materialForm.upload.data.savepath = "course_res_/socialTraining/";
                    let {name,size,uid} =file;
                    let obj = {name,size,uid,state:"上传中",img:require('../../../../static/images/sourceIcon/zip.png'),materialName,file};
                    this.showUploadFileList.push(obj);
                }

            },
            //上传文件移除
            handleRemove(file, fileList) {
                this.showUploadFileList = this.showUploadFileList.filter(x => x.uid!=file.uid);
            },
            handleAvatarError(err, file, fileList) {
                console.log(err)
                console.log(file)
                console.log(fileList)
            },
            handleAvatarSuccess(res, file) {
              let that = this
                // console.log(res, file,1111111111111)
                if (res.code == 0) {
                    //文件上传成功判断素材名称是否填写
                    this.materialForm.materialUpload = "success";
                    //上传完成进度设置成100%
                    let {data:{createTime}} = res;
                    // console.log(formatTime(createTime,"yyyy-MM-dd hh:mm:ss"),createTime)
                    this.showUploadFileList.forEach(item =>{
                        if(item.uid ==file.uid){
                            this.$set(item,'percentage',Number.parseInt(100))
                            this.$set(item,'state',"已完成")
                            this.$set(item,'createTime',formatTime(createTime,"yyyy-MM-dd hh:mm:ss"))
                        }
                    })
                    // console.log(res.data.id)
                    this.$emit('uploadMaterial', res.data.id)
                    //将每个结果对象放到数组
                    this.$refs["materialForm"].clearValidate();

                } else {
                    // console.log(res, file,2222222222222)
                    let fileId = file.uid;
                    this.showUploadFileList.forEach(item =>{
                        if(item.uid == fileId){
                            item.state="上传失败";
                        }
                    })
                    this.$message.error("格式不支持上传")
                }
            },
            //清除全部
            clearAllCompleted(){
              // this.isUploadingChecked -- 正在上传
              // this.isUploadCompletedChecked -- 上传完成
                this.$confirm('确定清除当前所有上传记录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if(this.isUploadCompletedChecked){
                        this.showUploadFileList = this.showUploadFileList.filter(x => x.state!="已完成");
                    }
                    if(this.isUploadingChecked){
                        this.$refs.addUpload.abort();
                        // this.showUploadFileList = this.showUploadFileList.filter(x => x.state=="上传中");
                        this.showUploadFileList = this.showUploadFileList.filter(x =>{
                            if(x.state!='上传中' &&  x.state!='上传失败'){
                                return true;
                            }
                        });
                        console.log(this.showUploadFileList,"xxxxxxxx")
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消清除'
                    });
                })
            },
            //上传完成
            uploadCompleted(){
                this.isUploadCompletedChecked=true;
                this.isUploadingChecked=false;
                if(this.isUploadCompletedChecked){
                    this.showText="清除全部";
                    this.showState="已完成";
                }else{
                    this.showState="";
                    this.showText="";
                }
            },
            //上传中
            uploading(){
                this.isUploadingChecked=true;
                this.isUploadCompletedChecked=false;
                if(this.isUploadingChecked){
                    this.showText="取消全部";
                    this.showState="上传中";
                }else{
                    this.showText="";
                    this.showState="";
                }

            },
            uploadProgress(event, file) {
                let uid = file.uid;
                this.showUploadFileList.forEach(item =>{
                    if(item.uid ==uid){
                        this.$set(item,'percentage',Number.parseInt(file.percentage))
                        // item.percentage=;
                        if(file.type == 'reload'){
                            this.$set(item,'state','正在上传')
                        }
                    }
                })
            },
            // 文件上传
            handlePreview(file) {
                console.log(file);
            },
            //删除上传文件
            uploadDel(site){
                this.$confirm('确定清除当前上传记录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let uid = site.uid;
                    // let file = {};
                    let fileList = this.$refs.addUpload.uploadFiles;
                    let file =  fileList.filter(item =>item.uid==uid).length>0?fileList.filter(item =>item.uid==uid)[0]:{};
                    //取消上传
                    this.$refs.addUpload.abort(file);
                    this.handleRemove(file,fileList);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消清除'
                    });
                })
            },
            close(){
              this.$emit('uploadMaterialClick')
            }
        },
    }
    const formatData = data =>  data.length > 0? data.map(v => ({children: formatData(v.children), label: v.name, value: v.id})):undefined;
</script>

<style scoped lang="scss">
  .uploadMaterial{
    .header{
      height: 50px;
      line-height: 50px;
      padding: 0px 10px;
      border-bottom:1px solid rgba(221,224,226,1);
      h3{
        font-size: 16px;
        color: #0D0D0D;
        font-weight: bold;
        i{
          display: inline-block;
          width:4px;
          height: 17px;
          background: #5397f7;
          vertical-align: middle;
          margin-right: 6px;
        }
      }
      img{
        position: absolute;
        right: 10px;
        top: 10px;
        width: 35px;
        cursor: pointer;
      }
    }
    .material-site{
      .sub{
        width: 38%;
      }
      .el-form{
        padding: 5px 10px;
        background:rgba(240,243,250,1);
        border-radius: 4px;
        height: 96px;
        display: flex;
      }
      /deep/ .el-form-item__content{
        display: inline-block;
        padding-right: 10px;
        margin-left: 0px!important;
      }
      .el-form-item__label{
        padding: 0px 8px 0px 0px;
      }
      .el-select{
        width: auto;
      }
      .app-wrapper .float-right .el-form{
        width: 90%;
        height: 48px;
        background: rgba(240,243,250,1);
      }
      /deep/ .el-upload {
        width: 72px;
        height: 72px;
        border-radius: 3px;
        line-height: 28px;
        text-align: left;
        background:rgba(213,218,237,1);
        margin-top: 8px;
      }
      .el-upload__text{
        padding: 15px;
        color: #D5DAED;
        font-size: 12px;
      }
      .addmater{
        margin-top: 8px;
      }
      /deep/ .el-input__inner {
        height: 34px;
        line-height: 34px;
        background-color: #fff;
      }
      /deep/ .el-form-item {
        margin-bottom: 1px;
      }
      .is-disabled{
        width: 260px;
      }
      /deep/ .el-input--suffix {
        width: 260px;
        height: 34px;
      }
      /deep/ .el-input__suffix {
        height: auto;
      }
      /deep/ .el-form-item__error {
        top: 89%;
      }
      /deep/ .el-message-box {
        width: 420px;
        height: 240px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
      }
      /deep/ .el-upload__tip{
        line-height: 20px;
        font-size:12px;
        font-family:Segoe UI;
        font-weight:400;
        color:rgba(148,152,163,1);
        margin-top: 0px;
        /*padding-bottom: 10px;*/
        /*border-bottom: 1px solid #e1e1e1;*/
      }
      .text-p{
        width: 43%;
        .tis-p{
          display: inline-table;
          color: #999;
          span{
            /*padding-left: 20px;*/
          }
        }
      }
      .uploadCompleted{
        width: 100%;
        position: relative;
        line-height: 30px;
        padding: 10px;
        box-sizing: border-box;
        .upload{
          background: #FFF;
          border: 1px solid #DCDFE6;
          color: #606266;
        }
        .active{
          color: #FFFFFF;
          background:rgba(83,151,247,1);
          border-radius:15px;
        }
        p{
          position: absolute;
          right: 10px;
          top: 8px;
          font-size: 12px;
          color: #9498A3;
        }
        .showText{
          position: absolute;
          right: 50px;
        }
      }
      .el-row{
        height: 48px;
        line-height: 48px;
        background: rgba(240,243,250,1);
        border-radius: 3px;
        margin: 15px 0;
        padding: 0px 5px;
        .el-col{
          color: #0D0D0D;
          font-size: 12px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          span{
            color: #9498A3;
            font-size: 12px;
            padding-right: 6px;
          }
          img{
            vertical-align: middle;
            padding-right: 6px;
            width: 24px;
          }
          em{
            font-style: normal;
            padding-right: 8px;
            display: inline-block;
          }
          .dataTime{
            color: #0D0D0D;
            font-size: 12px;
            padding-left: 10px;
          }
          .el-progress{
            line-height: 4;
          }
          /deep/ .el-progress__text{
            font-size: 12px!important;
          }
          b{
            color: #5397F7;
            font-size: 12px;
            i{
              width:4px;
              height:4px;
              background:rgba(83,151,247,1);
              border-radius:50%;
              display: inline-block;
              margin-right: 8px;
            }
          }
          .imgPic{
            margin: 0px 17%;
            display: inline-block;
            background: url("../../../assets/image/sources/new.png") no-repeat;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            &:hover{
              display: inline-block;
              background: url("../../../assets/image/sources/new-1.png") no-repeat;
              width: 16px;
              height: 16px;
              vertical-align: middle;
              cursor: pointer;
            }
          }
          .imgPicDel{
            display: inline-block;
            background: url("../../../assets/image/sources/del.png") no-repeat;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            position: absolute;
            right: 10px;
            top: 16px;
            &:hover{
              display: inline-block;
              background: url("../../../assets/image/sources/del-1.png") no-repeat;
              width: 16px;
              height: 16px;
              vertical-align: middle;
              cursor: pointer;
              position: absolute;
              right: 10px;
              top: 16px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/course/uploadMaterial.vue